import { SEND_DOCUMENTATION } from "./send";
import { STREAM_DOCUMENTATION } from "./stream";

const documentation = {
  STREAM_DOCUMENTATION,
  SEND_DOCUMENTATION,
};

export default documentation;
